// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "i.upsell-icon--tupwX.upsell-icon--tupwX{color:#ffa101}i.upsell-icon--tupwX.upsell-icon--tupwX.color-white{color:#fff}i.upsell-icon--tupwX.upsell-icon--tupwX.xs--RYuoA{font-size:12px}i.upsell-icon--tupwX.upsell-icon--tupwX.sm--QmKL4{font-size:16px}i.upsell-icon--tupwX.upsell-icon--tupwX.md--_Omlc{font-size:18px}i.upsell-icon--tupwX.upsell-icon--tupwX.lg--FmkHw{font-size:20px}i.upsell-icon--tupwX.upsell-icon--tupwX.xl--pgn01{font-size:24px}.locked-badge--kIHl2{border-radius:50%;padding:1.5px;background-color:#ffa101;color:#fff;z-index:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upsell-icon": "upsell-icon--tupwX",
	"xs": "xs--RYuoA",
	"sm": "sm--QmKL4",
	"md": "md--_Omlc",
	"lg": "lg--FmkHw",
	"xl": "xl--pgn01",
	"locked-badge": "locked-badge--kIHl2"
};
export default ___CSS_LOADER_EXPORT___;
